import styled from 'styled-components';
// old design
export const TableHeaderCell = styled.th `
  position: relative;
  text-align: left;
  height: 44px;
  background: #252525;
  padding-left: 16px;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  color: #ffffff;
  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    height: 20px;
    border-right: 1px solid #5a5a5a;
    margin: 12px 0 12px 0;
  }
`;
// new design
export const TableHeaderCellNew = styled.th `
  position: relative;
  text-align: left;
  height: 44px;
  background: #ffd643;
  padding: 10px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #272724;

  &::after {
    content: ' ';
    position: absolute;
    top: 0;
    right: 0;
    width: 1px;
    height: 20px;
    background: rgba(36, 39, 39, 0.2);
    margin: 12px 0;
  }
  &:last-child::after {
    display: none;
  }
`;
export const TableHeaderCellModal = styled.th `
  position: relative;
  text-align: left;
  height: 20px;
  background: transparent;
  padding: 0 10px 0 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ffffff;
  user-select: none;
  &:last-child {
    padding-right: 0;
  }
`;
